/**
 * For now, this mimics the DB mapping of store ID to displaying the dropdown
 * message, so that all the stores work properly.
 *
 * TODO: When we have the infrastructure for this, we can get rid of this function.
 */
export function storeToUrgencyMapping(shstoreId) {
  switch (shstoreId) {
    case 1:
      return {ticketsAtMinPrice: true, totalViews: true, enableUrgency: true, hotEvent: true};
    default:
      return {
        dropdownMsg: true,
        ticketsAtMinPrice: false,
        totalViews: false,
        ticketsLeft: true,
        sellingFast: true,
        enableUrgency: true,
        hotEvent: true,
      };
  }
}

/**
 * Method to check if the International Urgency is enabled based on several small features which requires i18n API to be called.
 * @param urgencyConfig  [object] Configuration for urgency for the current application.
 * @return i18nUrgencyFlag [boolean] The boolean flag indicating if the feature is ON/OFF.
 *
 */
export function i18nUrgencyFlag(urgencyConfig) {
  return (
    urgencyConfig &&
    urgencyConfig.enableUrgency &&
    (urgencyConfig.dropdownMsg || urgencyConfig.ticketsLeft || urgencyConfig.sellingFast || urgencyConfig.hotEvent)
  );
}
